<template>
  <div>
    <avue-form :option="tableOption">
        <template slot="menuForm" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-bottom: 0;
                background: #fff;
              "
              @click="$emit('searchChange',row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              v-if="permissions['chain:companywaybill:exc']"
              :loading="btnLoading"
              @click="$emit('exOutExcel')"
            >
              导出
            </el-button>
            <el-button
              v-if="permissions['chain:companywaybill:downImg']"
              size="small"
              :loading="btnLoading"
              @click="$emit('exportWaybillImage')"
            >
              导出运单图片
            </el-button>
            <el-button
              v-if="permissions['chain:companywaybill:downImg']"
              style="margin-right: 20px; margin-bottom: 0"
              size="small"
              @click="$emit('openUrl')"
            >
              导出图片工具
            </el-button>
            <span class="reset" @click="$emit('reset')"> 重置筛选条件 </span>
            <div class="expand" @click="expandSearch">
              <span v-if="isExpand == true"
                >收起 <i class="el-icon-arrow-up"></i
              ></span>
              <span v-if="isExpand == false"
                >展开 <i class="el-icon-arrow-down"></i
              ></span>
            </div>
          </div>
        </template>
    </avue-form>
  </div>
</template>

<script>
import { tableOption,tableOption1 } from "./searchOpt.js";
import {mapGetters} from 'vuex'
export default {
    data(){
        return {
            tableOption:tableOption1(this),
            isExpand:false,
            btnLoading:false,
            searchForm:{}
        }
    },
    computed:{
        ...mapGetters(["permissions"]),
    },
    methods:{
        expandSearch(){
            this.isExpand =!this.isExpand
            if(this.isExpand){
                this.tableOption= tableOption(this)
            }else{
                this.tableOption= tableOption1(this)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.avue-form__group--flex{
    padding-right: 16px;
}
.headerContent{
    margin-left: 89px!important;
}
/deep/.custom-label {
  .el-form-item__label {
    line-height: 17px !important;
  }
}
</style>